//dashboardApi.js

import { apiUrls, rtkTagTypes } from '../../constants/appConstants';
import { apiSlice } from '../services/apiSlice';

export const dashboardApi = apiSlice
  .enhanceEndpoints({
    tagTypes: rtkTagTypes,
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getDashboardData: builder.query({
        query(params) {
          return {
            url: `${apiUrls.getDashboardData}`,
            method: 'GET',
            params: params,
          };
        },
        transformResponse(res, _meta, _arg) {
          return res?.data;
        },
        providesTags: ['dashboardData'],
      }),
    }),
  });

export const { useGetDashboardDataQuery } = dashboardApi;
